import { defineStore } from "pinia";
import { FinancePayment } from "@core/store/types/webmaster/finances/modal/financePayment";

export const useFinancePaymentModal = defineStore("webmaster/financePaymentModal", {
  state: (): FinancePayment => ({
    isActive: false,
    currentTab: "payout"
  }),

  actions: {
  }
});